import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import CCSChip from '@ey/canvascoreservices/Chip';

const defaultVariants = ['default', 'success', 'warning', 'error', 'monochrome-light'];
const customVariants = ['blue', 'red', 'orange', 'green', 'purple', 'teal'];

const Chip = ({variant = 'default', className = null, interactive = false, isSelected = false, ...rest}) => {
	const isCustom = customVariants.includes(variant);

	const props = {
		...rest,
		className: classNames({
			[`${className}`]: !!className,
			['motif-chip-custom']: isCustom,
			['asu-chip-interactive']: interactive,
			['asu-chip-interactive-selected']: isSelected
		})
	};

	if (isCustom) props.$customColor = variant;
	else props.variant = variant;

	return <StyledCCSChip {...props} />;
};

Chip.propTypes = {
	variant: PropTypes.oneOf([...defaultVariants, ...customVariants]),
	className: PropTypes.string,
	interactive: PropTypes.bool,
	isSelected: PropTypes.bool
};

export default Chip;

const StyledCCSChip = styled(CCSChip)`
	/* For ellipsis to work */
	&.motif-chip,
	&.motif-chip .motif-chip-button {
		min-width: 0;
	}
	/* For variants */
	&.motif-chip:not(.motif-chip-active):not(.motif-chip-disabled) {
		&.motif-chip-custom {
			.motif-chip-button {
				--chip-outlined--border-color: var(${({$customColor}) => `--${$customColor}-100`});
				background-color: var(${({$customColor}) => `--${$customColor}-25`});
				color: var(${({$customColor}) => `--${$customColor}-700`});
			}
		}
	}
`;
